import React from "react";

const HideMenu = () => {
  return (
    <svg width="21px" height="13px">
      <g transform="matrix(1 0 0 1 -1544 -1287 )">
        <path
          d="M 0 2.16666666666667  L 0 0  L 14 0  L 14 2.16666666666667  L 0 2.16666666666667  Z M 0 10.8333333333333  L 14 10.8333333333333  L 14 13  L 0 13  L 0 10.8333333333333  Z M 0 5.41666666666667  L 16 5.41666666666396  L 16 3.25  L 21 6.5  L 16 9.75  L 15.999972135462 7.58333333333333  L 0 7.58333333333333  L 0 5.41666666666667  Z "
          fillRule="nonzero"
          fill="#000000"
          stroke="none"
          transform="matrix(1 0 0 1 1544 1287 )"
        />
      </g>
    </svg>
  );
};

export default HideMenu;
